module.exports = __webpack_public_path__ + "static/media/choithramsSearchG.257dbf76.png";